import { createFileRoute } from '@tanstack/react-router';
import { LandingPageFrame } from '@/features/consumer/landing-pages/landing-page-frame';

const LANDING_PAGE_SRC = '/landing-pages/landing-page-v1.html';

export const Route = createFileRoute('/landing-page-v1')({
  component: LandingPageV1,
  head: () => ({
    meta: [
      {
        title: 'Itria Home — Booking a cleaner, finally made simple',
      },
      {
        name: 'description',
        content:
          'Background-checked, reviewed cleaners for a flat $33 an hour. Watch the whole clean from your phone and pay for exactly the time you get.',
      },
      { name: 'robots', content: 'noindex' },
    ],
  }),
});

function LandingPageV1() {
  return (
    <LandingPageFrame
      src={LANDING_PAGE_SRC}
      title="Itria Home — Booking a cleaner, finally made simple"
      backgroundClassName="bg-[#0B0B0D]"
    />
  );
}
